import PlaceholderLayout from './placeholder.layout'

export default PlaceholderLayout
